import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { Card, Icon } from '@salesforce/design-system-react';

import './MenuCard.scss';

class MenuCard extends Component {
  render() {
    const iconProps = { size: 'large', ...this.props.icon };
    return (
      <Card className="menu-card" footer={this.props.footer}>
        <div className="menu-details">
          <Icon {...iconProps} />
          <h2>{this.props.title}</h2>
          <p>{this.props.info}</p>
        </div>
        {this.props.children}
      </Card>
    );
  }
}

MenuCard.propTypes = {
  title: PropTypes.string,
  info: PropTypes.string,
  icon: PropTypes.object,
  footer: PropTypes.object,
  location: PropTypes.object
};

export default injectIntl(MenuCard);
